import "./current-weather.css"
import React from 'react'

export default function CurrentWeather({ data }) {
  return (
    <div>

      <div className="weather">
        <div className="top">
          <div >
            <p className="city">{data.city}</p>

            {/* As description is as below */}
            {/* -> weather: Array(1)
   0:
   description: "moderate rain"
   icon: "10d"
   id: 501
   main: "Rain"        
   MEANING data THAT IS COMING BACK THEN INSIDE IT, ITS weather[0].description mean above data's 0th index
   */}
            <p className="weather-description">{data.weather[0].description}</p>
          </div>
          <img className="weather-icon" src={`icons/${data.weather[0].icon}.png`} alt="loading error" />
        </div>
        <div className="bottom">
          <p className="temperature">{Math.round(data.main.temp)}&deg;C</p>      {/* Check the response of line no 38 in console and SS 
    WHERE function name is main and temperature lies inside it with name as temp
    */}
          <div className="details">
            <div className="parameter-row">
              <span className="parameter-label" >Details</span>
            </div>
            <div className="parameter-row">
              <span className="parameter-label">Feels like</span>
              <span className="parameter-value" >{Math.round(data.main.feels_like)}&deg;C </span>
            </div>
            <div className="parameter-row">
              <span className="parameter-label">Wind</span>
              <span className="parameter-value">{data.wind.speed} m/s </span>
            </div>
            <div className="parameter-row">
              <span className="parameter-label">Humidity</span>
              <span className="parameter-value">{data.main.humidity}% </span>
            </div>
            <div className="parameter-row">
              <span className="parameter-label">Pressure</span>
              <span className="parameter-value">{data.main.pressure} hPa </span>
            </div>
            <div className="parameter-row">
              <span className="parameter-label">Sunrise</span>
              <span className="parameter-value">{new Date(data.sys.sunrise * 1000).toLocaleTimeString('EN-US')}</span>
            </div>
            <div className="parameter-row">
              <span className="parameter-label">Sunset</span>
              <span className="parameter-value">{new Date(data.sys.sunset * 1000).toLocaleTimeString('EN-US')} </span>
            </div>
            <div className="parameter-row">
              <span className="parameter-label">Visibility</span>
              <span className="parameter-value">{data.visibility * 0.001} km </span>
            </div>
          </div>

        </div>
      </div>



    </div>
  )
}
